import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { RiKey2Line } from '@remixicon/react';
import { rootRouteRef } from './routes';

const clientSecretsPage = PageBlueprint.make({
  params: {
    path: '/client-secrets',
    routeRef: rootRouteRef,
    title: 'Client Secrets',
    // The page renders its own `Page`/`Header`.
    noHeader: true,
    loader: () =>
      import('./components/ClientSecretsRoutes').then(m => (
        <m.ClientSecretsRoutes />
      )),
  },
});

export const azureKeyVaultSecretsPlugin = createFrontendPlugin({
  pluginId: 'azure-keyvault-secrets',
  title: 'Client Secrets',
  icon: <RiKey2Line />,
  routes: {
    root: rootRouteRef,
  },
  extensions: [clientSecretsPage],
});
